import React, { FC } from "react";    
import CountryDropdown from "./CountryDropdown"; 
import { AddressModel, CountryWithStateModel, StateModel } from "../models";
import { FlexContainer, Input, SingleSelect } from "@mindmemobile/mm-shared-global";

interface AddressFormProps {
  address: AddressModel;
  countriesWithState: CountryWithStateModel[];
  onAddressChange: (
    field: keyof AddressModel,
    value: string | CountryWithStateModel | StateModel
  ) => void;
}

const AddressFormComponent: FC<AddressFormProps> = ({
  address,
  countriesWithState,
  onAddressChange,
}) => {
  const handleChange = (
    field: keyof AddressModel,
    value: string | CountryWithStateModel | StateModel
  ) => {
    onAddressChange(field, value);
  };

  const textInput = (
    field: keyof AddressModel,
    type: string,
    value: string,
    placeholder: string
  ) => (
    <FlexContainer fxLayout="column">
      <Input
        type={type as "text"}
        value={value}
        className={`styled-input ${field}`}
        onChange={(e) => handleChange(field, e.target.value)}
        placeholder={placeholder}
        error={address.hasError(field)}
      />
    </FlexContainer>
  );

  const singleSelect = (
    field: keyof AddressModel,
    selectedKey: StateModel,
    className: string,
    options: StateModel[]
  ): React.ReactNode => {
    return (
      <SingleSelect
        selectedKey={selectedKey.name}
        errorMessage={"Please select state"}
        searchable={false}
        nameKeys={["name"]}
        valueKeys={["name"]}
        options={[options]}
        onChange={(option: StateModel) => handleChange(field, option)}
        className={className}
        hasError={address.hasError(field)}
      />
    );
  };

  const handleCountryChange = (countryId: string) => {
    const selectedCountry = countriesWithState.find(
      (country) => country.id === countryId
    );
    if (selectedCountry) {
      handleChange("countryDetails", selectedCountry);
    }
  };

  return (
    <FlexContainer fxLayout="column" spacing={10}>
      <CountryDropdown
        selectedCountry={address.countryDetails}
        onCountryChange={handleCountryChange}
        availableCountries={countriesWithState}
        error={address.hasError("country")}
        errorMessage={"Please select country"}
      />
      {textInput("address1", "text", address.address1, "Street Address 1")}
      {textInput("address2", "text", address.address2, "Street Address 2")}
      <FlexContainer alignItems="center" spacing={10}>
        {textInput("zipCode", "text", address.zipCode, "Zip")}
        {textInput("city", "text", address.city, "City")}
      </FlexContainer>
      {singleSelect(
        "state",
        address.state,
        "state state-dpdn",
        address.countryDetails.states
      )}
    </FlexContainer>
  );
};

export default AddressFormComponent;
